<template>
  <esg-base-dashboard>
    <b-row>
      <b-col md="6"
             lg="4">
        <!-- 1. 전사 스코프별 온실가스 배출량 -->
        <esg-base-dashboard-card title="온실가스 배출량"
                                 :subtitle="`(전사 - Scope 단위 - ${currentYear}년)`">
          <firmwide-emission-by-scope legend="bottom"/>
        </esg-base-dashboard-card>
        <!-- /전사 스코프별 온실가스 배출량 -->
      </b-col>

      <b-col md="6"
             lg="4">
        <!-- 2. 전사 최근 3개년 Scope별 온실가스 배출량 -->
        <esg-base-dashboard-card title="온실가스 배출량 추이"
                                 subtitle="(전사 - Scope 단위 - 과거 3개년)">
          <firmwide-emission-by-scope-for-three-years legend="bottom"/>
        </esg-base-dashboard-card>
        <!-- /전사 최근 3개년 Scope별 온실가스 배출량 -->
      </b-col>

      <b-col md="6"
             lg="4">
        <!-- 3. 전사 월별 온실가스 배출량 -->
        <esg-base-dashboard-card title="월별 온실가스 배출량 추이"
                                 :subtitle="`(전사 - Scope 단위 - ${currentYear}년)`">
          <firmwide-monthly-emission-by-scope @dataPointSelection="onDataPointSelection2"/>
        </esg-base-dashboard-card>
        <!-- /전사 월별 온실가스 배출량 -->

        <!-- 법인 월별 온실가스 배출량 모달 - 법인 선택 가능. 전사 월별 온실가스 배출량 데이터 선택 시 보임. -->
        <esg-base-dashboard-modal id="esg-ghg-dashboard-2"
                                  size="lg">
          <selectable-corp-monthly-emission-by-scope/>
        </esg-base-dashboard-modal>
        <!-- /법인 웗별 온실가스 배출량 모달 -->
      </b-col>

      <b-col md="6"
             lg="4">
        <!-- 4. 전사 법인별 온실가스 배출량 -->
        <sortable-firmwide-emission-by-corp/>
        <!-- /전사 법인별 온실가스 배출량 -->
      </b-col>

      <b-col md="6"
             lg="4">
        <!-- 5. 전사 법인별 탄소집약도 -->
        <esg-base-dashboard-card title="탄소 집약도"
                                 :subtitle="`(전사 - 법인 단위 - ${currentYear}년)`">
          <firmwide-carbon-intensity-by-corp @dataPointSelection="onDataPointSelection4"/>
        </esg-base-dashboard-card>
        <!-- /전사 법인별 탄소집약도 -->

        <!-- 사업장별 탄소 집약도 모달창 - 전사 법인별 탄소집약도의 데이터를 선택할 시 보임 -->
        <esg-base-dashboard-modal id="esg-ghg-dashboard-4"
                                  size="md">
          <esg-base-dashboard-card :title="`${corporation2.name} 사업장별 탄소집약도`">
            <corp-carbon-intensity-by-biz-loc :corporation="corporation2"/>
          </esg-base-dashboard-card>
        </esg-base-dashboard-modal>
        <!-- /사업장별 탄소 집약도 모달창 -->
      </b-col>

      <b-col md="6"
             lg="4">
        <!-- 6. 전사 에너지원별 사용량 -->
        <sortable-firmwide-energy-by-fuel @dataPointSelection="onDataPointSelection3"/>
        <!-- /전사 에너지원별 사용량 -->

        <!-- 법인 에너지원별 에너지 사용량 모달창 - 법인 선택 가능. 전사 에너지원별 사용량 데이터 선택 시 보임. -->
        <esg-base-dashboard-modal id="esg-ghg-dashboard-3"
                                  size="lg">
          <selectable-corp-energy-by-fuel/>
        </esg-base-dashboard-modal>
        <!-- /법인 에너지원별 에너지 사용량 모달창 -->
      </b-col>
    </b-row>
  </esg-base-dashboard>
</template>

<script>
// Base components
import EsgBaseDashboard from "@/components/esg/base/EsgBaseDashboard.vue";
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgBaseDashboardModal from "@/components/esg/base/EsgBaseDashboardModal.vue"

// Dashboard cards
import SelectableCorpEnergyByFuel from "../../dashboardCards/SelectableCorpEnergyByFuel.vue";
import SelectableCorpMonthlyEmissionByScope from "../../dashboardCards/SelectableCorpEmissionByMonth.vue";
import SortableFirmwideEmissionByCorp from "../../dashboardCards/SortableFirmwideEmissionByCorp.vue";
import SortableCorpEmissionByBizLoc from "../../dashboardCards/SortableCorpEmissionByBizLoc.vue";
import SortableFirmwideEnergyByFuel from "../..//dashboardCards/SortableFirmwideEnergyByFuel.vue";

// Charts
import FirmwideEmissionByScope from "../../charts2/FirmwideEmissionByScope.vue";
import FirmwideEmissionByScopeForThreeYears from "../../charts2/FirmwideEmissionByScopeForThreeYears.vue";
import FirmwideMonthlyEmissionByScope from "../../charts2/FirmwideMonthlyEmissionByScope.vue";
import FirmwideCarbonIntensityByCorp from "../../charts2/FirmwideCarbonIntensityByCorp.vue";
import CorpCarbonIntensityByBizLoc from "@/components/esg/3. Monitoring/charts2/CorpCarbonIntensityByBizLoc.vue";

export default {
  name: 'EsgGhgEmissionAmountManagement',
  components: {
    CorpCarbonIntensityByBizLoc,
    EsgBaseDashboard,
    EsgBaseDashboardCard,
    EsgBaseDashboardModal,

    SortableFirmwideEmissionByCorp,
    SortableFirmwideEnergyByFuel,
    SortableCorpEmissionByBizLoc,
    SelectableCorpEnergyByFuel,
    SelectableCorpMonthlyEmissionByScope,

    FirmwideEmissionByScope,
    FirmwideEmissionByScopeForThreeYears,
    FirmwideMonthlyEmissionByScope,
    FirmwideCarbonIntensityByCorp,
  },
  data() {
    return {
      corporation2: {}
    }
  },
  methods: {
    onDataPointSelection2() {
      this.$bvModal.show("esg-ghg-dashboard-2")
    },
    onDataPointSelection3() {
      this.$bvModal.show("esg-ghg-dashboard-3")
    },
    onDataPointSelection4(corporation) {
      this.corporation2 = corporation;
      this.$bvModal.show("esg-ghg-dashboard-4")
    }
  }
}
</script>
